export enum MedRecordStatus {
    InProcces = 0,
    Signed = 1
}